import { objectsRHandler } from '@/utils/objectsRHandler';

import Tag from '../list/tag';

const API_PATH = 'poll-question-categories';

export const QuestionTagManager = {
  objects: objectsRHandler(`${API_PATH}`, Tag),
};
